// apps/frontend/src/hooks/useSurveyDisplayGuard.ts
// Empeche le modal Community Voice de pop pendant les moments fragiles :
// checkout, onboarding Stripe, creation/edit annonce, upload, paiement.
// Retourne canShow=false si le contexte n'est pas approprie.
// Le hook re-evalue sur changement de route (hash router).

import { useEffect, useState } from 'react';

const CRITICAL_PATH_PATTERNS = [
  /\/checkout/i,
  /\/cart\/checkout/i,
  /\/stripe-onboarding/i,
  /\/stripe\/onboarding/i,
  /\/sell\/new/i,
  /\/sell\/edit/i,
  /\/products\/new/i,
  /\/products\/edit/i,
  /\/upload/i,
  /\/payment/i,
  /\/order\/confirm/i,
  /\/auth\/login/i,
  /\/auth\/register/i,
];

function isCriticalPath(): boolean {
  // BrowserRouter : le chemin est dans pathname (le hash est toujours vide).
  const path = window.location.pathname || '';
  return CRITICAL_PATH_PATTERNS.some(p => p.test(path));
}

function hasOpenModal(): boolean {
  // AdminNoticeModal a priorite : ne pas se superposer
  const noticeModal = document.querySelector('[data-modal="admin-notice"]');
  if (noticeModal) return true;
  // Tout modal critique marque par convention
  const critical = document.querySelector('[data-critical-modal-open]');
  return !!critical;
}

function hasCriticalActionInProgress(): boolean {
  return !!document.querySelector('[data-critical-action]');
}

export function useSurveyDisplayGuard() {
  const [canShow, setCanShow] = useState(() => evaluate());

  function evaluate(): boolean {
    if (isCriticalPath()) return false;
    if (hasOpenModal()) return false;
    if (hasCriticalActionInProgress()) return false;
    return true;
  }

  useEffect(() => {
    const onChange = () => setCanShow(evaluate());
    window.addEventListener('hashchange', onChange);
    // Re-evaluate periodiquement pour catcher fermetures de modal,
    // changements DOM (data-critical-action toggle, etc.)
    const id = setInterval(onChange, 2000);
    return () => {
      window.removeEventListener('hashchange', onChange);
      clearInterval(id);
    };
  }, []);

  return canShow;
}
